var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('router-view',{on:{"toggleLoading":_vm.toggleLoading}}),_c('Loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.is_loading),expression:"is_loading"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }